'use strict';

exports.MessageType = void 0;
(function (MessageType) {
  MessageType[MessageType["UnreadMessage"] = 0] = "UnreadMessage";
  MessageType[MessageType["RealTimeMessage"] = 1] = "RealTimeMessage";
})(exports.MessageType || (exports.MessageType = {}));
exports.ChannelType = void 0;
(function (ChannelType) {
  ChannelType[ChannelType["inhouse"] = 1] = "inhouse";
  ChannelType[ChannelType["salesforce"] = 2] = "salesforce";
})(exports.ChannelType || (exports.ChannelType = {}));
exports.UserSessionChannelType = void 0;
(function (UserSessionChannelType) {
  UserSessionChannelType[UserSessionChannelType["ChatbotChannel"] = 1] = "ChatbotChannel";
  UserSessionChannelType[UserSessionChannelType["SellerCenterChannel"] = 2] = "SellerCenterChannel";
  UserSessionChannelType[UserSessionChannelType["SellerEducationHubChannel"] = 3] = "SellerEducationHubChannel";
  UserSessionChannelType[UserSessionChannelType["WMSLiteChannel"] = 4] = "WMSLiteChannel";
  UserSessionChannelType[UserSessionChannelType["PremiumUserChannel"] = 5] = "PremiumUserChannel";
  UserSessionChannelType[UserSessionChannelType["ShopCNChannel"] = 6] = "ShopCNChannel";
  UserSessionChannelType[UserSessionChannelType["SpxChannel"] = 7] = "SpxChannel";
})(exports.UserSessionChannelType || (exports.UserSessionChannelType = {}));
exports.ENTRY_POINT_IN_URL = void 0;
(function (ENTRY_POINT_IN_URL) {
  ENTRY_POINT_IN_URL[ENTRY_POINT_IN_URL["general"] = 0] = "general";
  ENTRY_POINT_IN_URL[ENTRY_POINT_IN_URL["mePage"] = 1] = "mePage";
  ENTRY_POINT_IN_URL[ENTRY_POINT_IN_URL["sellingPage"] = 2] = "sellingPage";
  ENTRY_POINT_IN_URL[ENTRY_POINT_IN_URL["shippingPage"] = 3] = "shippingPage";
  ENTRY_POINT_IN_URL[ENTRY_POINT_IN_URL["helpCentre"] = 4] = "helpCentre";
})(exports.ENTRY_POINT_IN_URL || (exports.ENTRY_POINT_IN_URL = {}));
exports.GRAY_RELEASE_CONFIG_ENTRY_POINT = void 0;
(function (GRAY_RELEASE_CONFIG_ENTRY_POINT) {
  GRAY_RELEASE_CONFIG_ENTRY_POINT["MePage"] = "mepage";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["HelpCentre"] = "helpcentre";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["Mitra"] = "mitra";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["MyStock"] = "wms_lite";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["SPX"] = "spx_main_page";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["SPXHelp"] = "spx_help_center";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["driverOrderPage"] = "driver_app";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["driverHelpcenter"] = "driver_app";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["driverSpxOrderPage"] = "driver_app";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["Cncb"] = "cncb";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["CncbMain"] = "cncb_main";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["BankHelpCenter"] = "bank";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["BankMePage"] = "bank";
  GRAY_RELEASE_CONFIG_ENTRY_POINT["Other"] = "other";
})(exports.GRAY_RELEASE_CONFIG_ENTRY_POINT || (exports.GRAY_RELEASE_CONFIG_ENTRY_POINT = {}));
exports.UserType = void 0;
(function (UserType) {
  //系统消息
  UserType[UserType["Sys"] = 1] = "Sys";
  UserType[UserType["Anonymous"] = 101] = "Anonymous";
  UserType[UserType["Seller"] = 102] = "Seller";
  UserType[UserType["Buyer"] = 103] = "Buyer";
  // 机器人，仅用于 chatbot 历史消息数据上传到 InHouseCS 的场景
  UserType[UserType["BOT"] = 200] = "BOT";
  // 人工客服
  UserType[UserType["LocalCS"] = 201] = "LocalCS";
  UserType[UserType["SERVICE_ASSISTANT"] = 202] = "SERVICE_ASSISTANT";
})(exports.UserType || (exports.UserType = {}));
// 1：chatbot（default）；2：seller centre；3: seller education hub; 4: WMS Lite
exports.SellerChannel = void 0;
(function (SellerChannel) {
  SellerChannel[SellerChannel["chatbot"] = 1] = "chatbot";
  SellerChannel[SellerChannel["sellerCentre"] = 2] = "sellerCentre";
  SellerChannel[SellerChannel["sellerEducationHub"] = 3] = "sellerEducationHub";
  SellerChannel[SellerChannel["WMSLite"] = 4] = "WMSLite";
  SellerChannel[SellerChannel["premium"] = 5] = "premium";
  SellerChannel[SellerChannel["shopeeCn"] = 6] = "shopeeCn";
  SellerChannel[SellerChannel["shopeeCnEdu"] = 6] = "shopeeCnEdu";
  SellerChannel[SellerChannel["shopeeWeChat"] = 6] = "shopeeWeChat";
})(exports.SellerChannel || (exports.SellerChannel = {}));
exports.SystemType = void 0;
(function (SystemType) {
  SystemType[SystemType["general"] = 0] = "general";
  SystemType[SystemType["ShopeeAndroid"] = 1] = "ShopeeAndroid";
  SystemType[SystemType["ShopeeIos"] = 2] = "ShopeeIos";
  SystemType[SystemType["DriverAndroid"] = 3] = "DriverAndroid";
  SystemType[SystemType["DriverIos"] = 4] = "DriverIos";
  SystemType[SystemType["BankAndroid"] = 5] = "BankAndroid";
  SystemType[SystemType["BankIos"] = 6] = "BankIos";
})(exports.SystemType || (exports.SystemType = {}));
exports.SessionStatus = void 0;
(function (SessionStatus) {
  SessionStatus[SessionStatus["Deflected"] = 1] = "Deflected";
  SessionStatus[SessionStatus["Queuing"] = 2] = "Queuing";
  SessionStatus[SessionStatus["Missed"] = 3] = "Missed";
  SessionStatus[SessionStatus["Chatting"] = 4] = "Chatting";
  SessionStatus[SessionStatus["End"] = 5] = "End";
})(exports.SessionStatus || (exports.SessionStatus = {}));
exports.UserEntryType = void 0;
(function (UserEntryType) {
  UserEntryType[UserEntryType["APP"] = 1] = "APP";
  UserEntryType[UserEntryType["PC"] = 2] = "PC";
})(exports.UserEntryType || (exports.UserEntryType = {}));
exports.MsgFlow = void 0;
(function (MsgFlow) {
  MsgFlow[MsgFlow["UserToCS"] = 1] = "UserToCS";
  MsgFlow[MsgFlow["CSToUser"] = 2] = "CSToUser";
  MsgFlow[MsgFlow["SysToUser"] = 3] = "SysToUser";
  MsgFlow[MsgFlow["SysToCS"] = 4] = "SysToCS";
})(exports.MsgFlow || (exports.MsgFlow = {}));
var PrechatDetailItem = /** @class */function () {
  function PrechatDetailItem(label, value, transcriptFields, displayToAgent) {
    if (label === void 0) {
      label = '';
    }
    if (value === void 0) {
      value = '';
    }
    if (transcriptFields === void 0) {
      transcriptFields = [];
    }
    if (displayToAgent === void 0) {
      displayToAgent = true;
    }
    this.label = label;
    this.value = value;
    this.transcriptFields = transcriptFields;
    this.displayToAgent = displayToAgent;
  }
  return PrechatDetailItem;
}();
exports.UserSessionStatus = void 0;
(function (UserSessionStatus) {
  UserSessionStatus[UserSessionStatus["initial"] = 10] = "initial";
  UserSessionStatus[UserSessionStatus["created"] = 20] = "created";
  UserSessionStatus[UserSessionStatus["queuing"] = 30] = "queuing";
  UserSessionStatus[UserSessionStatus["chatting"] = 40] = "chatting";
  UserSessionStatus[UserSessionStatus["ended"] = 50] = "ended";
})(exports.UserSessionStatus || (exports.UserSessionStatus = {}));
exports.USER_QUEUE_TYPE = void 0;
(function (USER_QUEUE_TYPE) {
  USER_QUEUE_TYPE[USER_QUEUE_TYPE["normal"] = 1] = "normal";
  USER_QUEUE_TYPE[USER_QUEUE_TYPE["premium"] = 2] = "premium";
})(exports.USER_QUEUE_TYPE || (exports.USER_QUEUE_TYPE = {}));
exports.ERROR_MESSAGE = void 0;
(function (ERROR_MESSAGE) {
  ERROR_MESSAGE["RESEND_MESSAGE"] = "resend message";
})(exports.ERROR_MESSAGE || (exports.ERROR_MESSAGE = {}));
exports.PrechatDetailItem = PrechatDetailItem;